import { Dropdown, type DropdownOption } from '@/components/ui'

export const severityCodes = [
  { value: '', label: '' },
  { value: '1', label: 'Informational' },
  { value: '2', label: 'Warning' },
  { value: '3', label: 'Critical' },
]

interface Params {
  values?: string[]
  onChange: (values?: string[]) => void
}

export type SeverityNames = 'critical' | 'warning' | 'informational'

export const getSeverityLabel = (value: string) => severityCodes.find((c) => c.value === value)?.label || ''

export const SeverityDropdown: React.FC<Params> = ({ values, onChange }) => {
  const arr = (typeof values === 'string' ? [values] : values) || []
  return (
    <div>
      <label>Severity</label>
      <Dropdown
        options={severityCodes}
        handleMultiSelectItem={(opt: DropdownOption[]) => {
          const selectedValues = opt.filter((option) => option.value !== '').map((option) => option.value)
          const newValues = selectedValues.length > 0 ? selectedValues : undefined
          onChange(newValues)
        }}
        isMultiSelect
        includeSelectAll
        selectedItem={arr.length ? severityCodes.filter((o) => arr.includes(o.value)) : []}
        placeholder="Choose one or more severity codes"
      />
    </div>
  )
}
